// Module
var code = "<h2 id=\"forgiveness--discharge-forms\">Forgiveness &amp; Discharge Forms</h2> <p>Find out if you are eligible to have your loan debt reduced or eliminated. </p> ";
// Exports
export default code;